import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { ConfirmationModal, FlexColumn, Body } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Container = styled(FlexColumn)`
  flex: 1;
  align-items: flex-start;
`;

const MessageHeader = styled(Body)`
  margin-bottom: 2%;
`;

const MarkAsOpenShiftPrompt = ({ onClose, onConfirm }) => {
  const { t } = useContext(ConfigContext);
  const [isLoading, setIsLoading] = useState(false);

  const onResponseClick = async ({ isConfirm }) => {
    setIsLoading(true);
    await onConfirm({ markAsOpenShift: !!isConfirm });
    setIsLoading(false);
    onClose();
  };

  return (
    <ConfirmationModal
      onClose={onClose}
      showCancelButton
      onCancelClick={async () => {
        await onResponseClick({ isConfirm: false });
      }}
      size="small"
      title={t('markAsOpenShiftModalTitle')}
      onConfirm={async () => {
        await onResponseClick({ isConfirm: true });
      }}
      confirmText={t('yes')}
      cancelText={t('no')}
      loadingConfirm={isLoading}
      usePortal>
      <Container>
        <MessageHeader>{t('markAsOpenShiftModalBody')}</MessageHeader>
      </Container>
    </ConfirmationModal>
  );
};

export default MarkAsOpenShiftPrompt;
